<template>
  <component :is="htmlTag" v-if="title !== undefined" class="heading" :class="classes">
    {{ title }}
  </component>
</template>

<script setup lang="ts">

const props = defineProps<{
  title: string
  level: number
}>()

const htmlTag = computed(() => {
  return `h${props.level}`
})

const classes = computed(() => {
  return `heading--level-${props.level}`
})

</script>

<style lang="scss" scoped>
@use "~/assets/sass/tools";

.heading {
  @include tools.page-grid-columns;
  margin: calc(var(--space--l) - var(--grid-gutter)) 0 0;

  &--level-1 {
    @include tools.page-grid-columns-wide;
    margin: calc(var(--space--xl) - var(--grid-gutter)) 0 calc(var(--space--xxl) - var(--grid-gutter));
  }

  + .heading {
    margin-top: 0;
  }
}
</style>
